import { Box } from '@mui/material';
export function EnvironmentBanner() {
  const appEnvironment = import.meta.env.PCC_APP_ENVIRONMENT;
  const colors: Record<string, string> = {
    dev: 'orange',
    local: 'salmon',
    staging: 'purple',
  };
  return appEnvironment && appEnvironment !== 'production' ? (
    <Box
      sx={{
        background: colors[appEnvironment],
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        color: '#fff',
        fontFamily: 'monospace',
        fontSize: 14,
        left: '50%',
        margin: 'auto',
        position: 'fixed',
        textAlign: 'center',
        transform: `translateX(-50%)`,
        width: 180,
        zIndex: 99999999,
      }}
    >
      {appEnvironment} environment
    </Box>
  ) : null;
}
